import { render, staticRenderFns } from "./SwitchHandle.vue?vue&type=template&id=3812a029&"
import script from "./SwitchHandle.vue?vue&type=script&lang=js&"
export * from "./SwitchHandle.vue?vue&type=script&lang=js&"
import style0 from "./SwitchHandle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports